var map = {
	"./auth/router.js": "PeWl",
	"./main/router.js": "FNF9",
	"./plan/router.js": "fOz7",
	"./user-center/account/router.js": "EHeJ",
	"./user-center/news/router.js": "g98M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pejq";


//////////////////
// WEBPACK FOOTER
// ./src/modules router.js$
// module id = Pejq
// module chunks = 58